// extracted by mini-css-extract-plugin
export default {"contact_main":"contact_contact_main__o73jx","contact_title":"contact_contact_title__cjroJ","contact_links":"contact_contact_links__8qsvQ"};